module.exports = __webpack_public_path__ + "static/media/financeCarousel3.b8c54e7e.jpg";